export const VERSION_WEB = "0.0.12";

// export const WEB_FILE_URL = "http://122.155.0.74:5201/";
// export const WEB_API = "http://122.155.0.74:5201/api/";
//export const WEB_FILE_URL = "https://localhost:44337/";
//export const WEB_API = "https://localhost:44337/api/";
export const WEB_FILE_URL = "https://edoc-service-api-prd.azurewebsites.net/";
export const WEB_API = "https://edoc-service-api-prd.azurewebsites.net/api/";

// export const WEB_FILE_URL = "https://edoc-service-api-dev.azurewebsites.net/";
// export const WEB_API = "https://edoc-service-api-dev.azurewebsites.net/api/";

// export const adfs_redirect_url = "http://localhost:3990/";
// export const adfs_client_id = "7197d1ad-7dc9-4163-9179-f3ad748817f4";
